import { PayloadAction } from '@reduxjs/toolkit';
import { ContentReducerCreator } from '../types';

const finishUploadJobReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<string>) => {
    state.uploadJobs = state.uploadJobs.filter((job) => job.uuid !== action.payload);
  });
};

export default finishUploadJobReducer;
